<div class="caja-iconos iconos__propiedades">
  @if (authService.isLoggedIn()) {
  <div class="btn btn-sm rounded-circle btn-lista" (click)=lista(articulo)><i class="fa "
      [ngClass]="{'fa-heart-o': articulo.lista_pedcl_id === null || pedidoService.lista.length <= 0 , 'fa-heart': articulo.lista_pedcl_id !==null}"></i>
  </div>
  }
  @if (articulo.marca_propia!=='P') {
  <div class="btn btn-sm rounded-circle" style="color: orangered" data-toggle="tooltip" data-placement="top"
    title="Marca propia">
    <i class="fa fa-certificate"></i>
  </div>
  }
  @if (articulo.novedad=='S') {
  <div class="btn btn-sm rounded-circle" style="color: orangered" data-toggle="tooltip" data-placement="top"
    title="Novedad">
    <i class="fa fa-calendar-check"></i>
  </div>
  }
  @if (filtrosShop.hasOwnProperty('mascomprado') && filtrosShop.mascomprado && articulo.top30 !==null) {
  <div class="btn btn-sm rounded-circle" style="color: orangered" data-toggle="tooltip" data-placement="top"
    title="Más consumido">
    <i class="fa fa-thermometer-full"></i>
  </div>
  }
  @if (COMPRAR_SIN_STOCK !== 'N' && articulo.stock_uni < 1) { <div class="btn btn-sm rounded-circle"
    style="color: orangered" data-toggle="tooltip" data-placement="top" title="Actualmente sin stock">
    <i class="fa fa-lock"></i>
</div>
}
<!-- <div class="btn btn-sm rounded-circle" style="flex: 1 0; color: #fff"><i class="fa fa-bookmark"></i></div> -->
@if (articulo.ult_cantidad !== null && artYYYY === diaYYYY) {
<div class="small pr-1 info__widget">
  <i class="fa fa-shopping-basket" style="color: orangered"></i>
  @if(gridList)
  {
  {{articulo.ult_cantidad }}
  {{articulo.ult_tipo_bulto}} {{ articulo.ult_fecha | date: 'd-MMM'}}
  }
</div>
}
@if (articulo.ult_cantidad !== null && artYYYY !== diaYYYY) {
<div class="small pr-1 info__widget">
  <i class="fa fa-shopping-basket" style="color: orangered"></i>
  @if(gridList)
  {
  {{articulo.ult_cantidad }}
  {{articulo.ult_tipo_bulto}} {{ articulo.ult_fecha | date: 'MMM-y'}}
  }
</div>
}
@if ((articulo.modo_facturar == 'C' ||(articulo.art_peso === 'S' && this.ART_PESO_VER_PESO)) && articulo.peso_unid!=null
&& articulo.peso_unid > 0) {
<div class="small pr-1">
  <i class="fa fa-balance-scale" style="color: orangered"></i> {{articulo.peso_unid }} kg
</div>
}
</div>